import Vue from "vue";
import Vuex from "vuex";
import cal from "./modules/cal/index";
import events from "./modules/events/index";
import client from "./modules/client/index";
import expert from "./modules/expert/index";
import routes from "./modules/routes/index";
import project from "./modules/project/index";
import credit from "./modules/credit/index";
import vacation from "./modules/vacation/index";
import sendgrid from "./modules/sendgrid";
import dashboard from "./modules/dashboard";

import appointments from "./modules/appointments/index";
import availabilities from "./modules/availabilities/index";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        cal,
        appointments,
        availabilities,
        events,
        client,
        expert,
        routes,
        project,
        credit,
        vacation,
        sendgrid,
        dashboard,
    },
    strict: debug,
});
